<template>
  <div>
    <header-bar>YouTubeマネタイズ</header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">手動申し立て動画検索</h3>
      </div>
      <div class="page-block__inner">
        <div
          class="youtube-btn-wrap">
          <div
            class="youtube-search-wrap"
            style="margin-bottom: 22px;">
            <input
              v-model="videoId"
              class="youtube-search"
              placeholder="動画ID"
              type="search"
              @search="onClickedSearch('', $event)"
              @keydown.prevent.enter="onClickedSearch('enter', $event)">
            <a
              class="c-btn c-btn--search"
              @click.prevent="onClickedSearch('',$event)">
              <img src="/img/common/icon-search.png" />検索
            </a>
          </div>
        </div>
        <video-table
          v-if="video.channelId"
          :video="video"
          @request="onRequestClicked" />
        <div
          v-if="video.channelId"
          class="page-block__request">
          <a
            v-if="audioMatches && audioMatches.length"
            href="#"
            disabled
            class="c-btn c-btn--small c-btn--back">
            音声の一致する動画があるため、申し立てできません
          </a>
          <a
            v-else
            class="c-btn c-btn--edit"
            href="#"
            @click.prevent="onRequestClicked">
            この動画に申し立て
            <span class="c-btn--delivery c-btn__icon-arrow--right"></span>
          </a>
        </div>
        <you-tube-claims-claim-request-table
          v-if="audioMatches && audioMatches.length"
          :items="audioMatches"
          :video="video" />
        <div
          class="page-block__request">
          <a
            v-if="audioMatches && audioMatches.length"
            href="#"
            class="c-btn"
            @click.prevent="onInactiveClaimClicked">
            申し立てを取り下げる
          </a>
        </div>

        <div
          v-if="errorMessage"
          class="error-message">
          {{ errorMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../../../HeaderBar'
import YouTubeClaimsVideoTable from './VideoTable'
import YouTubeClaimsClaimRequestTable from '../Search/ClaimRequestTable'

export default {
  name: 'YouTubeClaimsRequestIndex',
  components: {
    YouTubeClaimsClaimRequestTable,
    HeaderBar,
    VideoTable: YouTubeClaimsVideoTable,
  },
  data() {
    return {
      videoId: '',
      video: {},
      audioMatches: [],
      error: null,
      errorMessage: null,
    }
  },
  mounted() {
    if (this.$route.query.video_id) {
      this.videoId = this.$route.query.video_id
      this.fetchItems(this.videoId)
    }
  },
  methods: {
    onClickedSearch(type, event) {
      if (type === 'enter' && event.keyCode !== 13) {
        return
      }
      if (this.videoId === '') {
        this.video = {}
        this.audioMatches = []
        this.modalVideoId = null
        return
      }
      this.fetchItems(this.videoId, true)
    },
    async fetchItems(videoId, reload = false) {
      this.errorMessage = null
      this.video = {}
      this.audioMatches = []
      this.error = null
      if (reload) {
        // URL に履歴を残す
        const query = { video_id: videoId }
        this.$router.replace({ name: 'youtube-claims-request-index', query }, () => {}, () => {})
      }
      try {
        // 検索結果を取得
        const { data } = await window.axios.get(`/api/client/youtube/claims/video/${videoId}`)
        this.video = data.video
        this.audioMatches = data.audioMatches
      } catch (e) {
        const { response } = e
        const { status } = response
        if (status === 404) {
          this.video = {}
          this.errorMessage = '検索結果が見つかりませんでした'
        }
        this.error = e
      }
    },
    onRequestClicked() {
      // 申請画面に遷移
      this.$router.push({
        name: 'youtube-claims-request-form',
        params: { videoId: this.videoId },
      })
    },
    async onInactiveClaimClicked() {
      const params = {
        video_id: this.audioMatches[0].videoId,
        asset_id: this.audioMatches[0].assetId,
      }
      const claimId = this.audioMatches[0].id
      try {
        const { data } = await window.axios.put(`/api/client/youtube/claims/${claimId}`, params)

        if (data.message === 'success') {
          this.fetchItems(this.videoId, true)
        }
      } catch (e) {
        this.errorMessage = e.message
        this.completed = false
      }
    },
  },
}
</script>

<style scoped>
.error-message {
  color: #ff0000;
  font-size: 16px;
  margin: 20px auto 120px 20px;
  text-align: left;
}
.page-block__request {
  margin-top: 20px;
  text-align: center;
}
</style>
